/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * События для `ecommerce`
   */
  app.EcommerceEvents = app.View.extend({

    searchInitFlag: true,               // флаг инициализации поиска (открытие страницы с первоначальными данными)
    searchQueryFlag: false,             // флаг изменения поискового запроса
    searchParamsFlag: false,            // флаг изменения параметров поиска
    searchPaginationFlag: false,        // флаг пагинации на странице поиска
    searchInfiniteScrollFlag: false,    // флаг бесконечного скролла  на странице поиска

    catalogParamsFlag: false,           // флаг изменения фильтров на странице каталога
    catalogPaginationFlag: false,       // флаг паганации на странице каталога
    catalogInfiniteScrollFlag: false,   // флаг бесконечного скролла на странице каталога

    cartInfiniteScrollFlag: false,      // флаг бесконечного скролла на странице корзины
    /**
     * @inheritDoc
     */
    run: function () {
      this.dataLayer = dataLayer;

      this.listenTo(app.cart, 'add', this.eventAddCartProduct);
      this.listenTo(app.cart, 'remove', this.eventRemoveCartProduct);
      this.listenTo(app.cart, 'change:qty', this.eventChangeCartProductQty);

      // свернули/развернули фильтр
      this.listenTo(app.EventBus, 'filter.section.toggle.view', this.toggleFilterView);
      // показать ещё/скрыть параметры фильтра
      this.listenTo(app.EventBus, 'filter.section.toggle.side', this.toggleFilterView);

      // в поиске
      if (typeof app.search !== 'undefined') {
        // открытие страницы поиска
        this.listenTo(app.search, 'sync', this.eventSearch);

        this.listenTo(app.searchRouter, 'change-get-params', this.runFlagChangeMethod);
        // при запросе фильтров без моделей роутер не работает.
        this.listenTo(app.searchRouter, 'change-filter', this.eventSearchParams());

        // бесконечная пагинация
        this.listenTo(app.categoryCommonView, 'InfiniteScroll', this.eventSearchInfiniteScroll);
      }

      // категория товаров
      if (typeof app.category !== 'undefined') {
        this.listenTo(app.category, 'sync', this.eventCategory);

        this.listenTo(app.categoryRouter, 'change-get-params', this.runFlagChangeMethod);
        // при запросе фильтров без моделей роутер не работает.
        this.listenTo(app.categoryRouter, 'change-filter', this.eventCategoryParams());

        // бесконечная пагинация
        this.listenTo(app.categoryCommonView, 'InfiniteScroll', this.eventCategoryInfiniteScroll);
      }

      // корзина
      if (typeof  app.cartRouter !== 'undefined') {
        this.listenTo(app.cart, 'sync', this.eventCart);
        // бесконечная пагинация
        this.listenTo(app.cartCommonView, 'InfiniteScroll', this.eventCartInfiniteScroll);
      }

      // оформление заказа
      if (typeof app.orderFormView !== 'undefined') {
        this.listenTo(app.orderFormView, 'success', this.orderSuccess);
      }

      // страница избранного
      if (typeof app.wishItems !== 'undefined') {
        this.listenTo(app.wishItems, 'sync', this.eventWish);

        this.listenTo(app.wishRouter, 'change-get-params', this.runFlagChangeMethod);
        // при запросе фильтров без моделей роутер не работает.
        this.listenTo(app.wishRouter, 'change-filter', this.eventWishParams());
        // бесконечная пагинация
        this.listenTo(app.categoryCommonView, 'InfiniteScroll', this.eventWishInfiniteScroll);
      }
    },
    /**
     * Обработка изменения параметров роутера.
     * Вызывает соответствующий параметру метод.
     *
     * @param paramKeys {Array} названия параметров
     * @param type {String} тип коллекции
     */
    runFlagChangeMethod: function (paramKeys, type) {
      var that = this,
      typePart = _.capitalize(type);

      paramKeys.filter(function(param){
        // qc это часть query - нет смысла триггерить два раза
        return param !== 'qc';
      }).forEach(function (param) {
        switch(param) {
          case 'page':
            that['event' + typePart + 'Pagination']();
            break;
          case 'q':
            that['event' + typePart + 'Query']();
            break;
          default:
            that['event' + typePart + 'Params']();
        }
      });
    },

    /**
     * Добавление товара в корзину.
     *
     * @param {app.CartItem} model
     */
    eventAddCartProduct: function (model) {
      var productData = this.getProductCartProperty(model);

      this.pushData({
        event: 'addToCart',
        quantity: productData.quantity,
        price: productData.price,
        eventProductId: productData.id,
        rootCategory: model.get('root_category_id'),
        ecommerce: {
          currencyCode: model.get('currency'),
          add: {
            products: [
              productData
            ]
          }
        }
      });
    },

    /**
     * Удаление товара из корзины.
     *
     * @param {app.CartItem} model
     */
    eventRemoveCartProduct: function (model) {
      var productData = this.getProductCartProperty(model);

      this.pushData({
        event: 'removeFromCart',
        quantity: productData.quantity,
        price: productData.price,
        eventProductId: productData.id,
        rootCategory: model.get('root_category_id'),
        ecommerce: {
          currencyCode: model.get('currency'),
          remove: {
            products: [
              productData
            ]
          }
        }
      });
    },

    /**
     * Изменение кол-ва товара в корзины.
     *
     * @param {app.CartItem} model
     */
    eventChangeCartProductQty: function (model) {
      var qtyDelta = parseInt(model.get('qty')) - parseInt(model.previous('qty'));

      // её отправим далее
      var sendedModel = model.clone();
      sendedModel.attributes = _.clone(model.attributes);
      sendedModel.set({qty: Math.abs(qtyDelta)}); // указываем сколько было добавлено/удалено

      // @todo: иногда всплывает событие на удаление `0` кол-ва товара, на сервер всё отправляется как надо, это где-то в дебрях JS.
      if (!qtyDelta) {
        return;
      }

      if (qtyDelta > 0) {
        // увеличили
        this.eventAddCartProduct(sendedModel);
      } else {
        // уменьшили
        this.eventRemoveCartProduct(sendedModel);
      }
    },

    /**
     * Страница поиска товаров, данные отправляются при смене товара на странице, если товар сменён без перезагрузки
     * страницы то дописывается поле `event` взависимости от причины смены товара имеет значение `pagination` или
     * `changeParams`.
     *
     * @param {app.Search} collection
     */
    eventSearch: function (collection) {
      // т.к. при бесконечном скролле набор моделей суммируется то нужны только последние пришедшие модели
      if (this.searchInfiniteScrollFlag) {
        collection = collection.slice(collection.state.itemsInResponse * (-1));
      }

      var that = this,
        response = {
        ecommerce: {
          currencyCode: collection.currencyId,
          impressions: collection.map(function (item) {
            return that.getProductProperty(item);
          })
        }
      };

      response.ecomm_pagetype = 'searchresults';
      response.ecomm_prodid = this.getAdwordsProductData(response.ecommerce.impressions, 'id');
      response.ecomm_totalvalue = this.getAdwordsProductData(response.ecommerce.impressions, 'price');

      // @todo: спрятать всё это, включая подписку и реакцию на события

      // изменение параметров состоит из двух флагов: изменение всего кроме пагинации и поискового запроса и изменение поискового запроса.
      this.searchParamsFlag = this.searchParamsFlag | this.searchQueryFlag;

      // изменился только номер страницы
      if (!this.searchParamsFlag && (this.searchPaginationFlag || this.searchInfiniteScrollFlag)) {
        response.event = 'pagination';
      }
      // изменились параметры поиска
      if (this.searchParamsFlag) {
        response.event = 'changeParams';
      }

      // изменился поисковый запрос
      if (this.searchQueryFlag || this.searchInitFlag) {
        response.Keyword = app.search.query;
        response.Number_of_products = app.search.state.totalRecords;
      }
      if (this.searchInitFlag) {
        // получаем sid'ы первых 10-и найденных товаров
        var sidList = response.ecomm_prodid;
        // получаем hash email'а пользователя
        var userEmail = replaceDataLayer.replace_email;
        // получаем строку поиска
        var q = app.search.query;

        response.event = 'search';
        response.criteo = {
          'criteo': [
            {'event': 'setAccount', 'account': 18591},
            {'event': 'setHashedEmail', 'email': userEmail},
            {'event': 'setSiteType', 'account': 'd'},
            {'event': 'viewList', 'item': sidList, 'keywords': q}
          ]
        };
      }

      if (response.event === undefined) {
        return;
      }

      this.searchInitFlag = false;
      this.searchQueryFlag = false;
      this.searchParamsFlag = false;
      this.searchPaginationFlag = false;
      this.searchInfiniteScrollFlag = false;

      this.pushData(response);
    },
    /**
     * Устанавливает флаг наличия параметров в поиске
     */
    eventSearchParams: function () {
      this.searchParamsFlag = true;
    },
    /**
     * Устанавливает флаг наличия пагинации в поиске
     */
    eventSearchPagination: function () {
      this.searchPaginationFlag = true;
    },
    /**
     * Устанавливает флаг наличия бесконечной прокрутки в поиске
     */
    eventSearchInfiniteScroll: function () {
      this.eventSearchPagination();
      this.searchInfiniteScrollFlag = true;
    },
    /**
     * Устанавливает флаг наличия поискового запроса в поиске
     */
    eventSearchQuery: function () {
      this.searchQueryFlag = true;
    },

    /**
     * Страница категории товаров. Данные отправляются в `ecommerce` только если произошла смена товара
     * без перезагрузки страницы. Взависимости от причины смены товара поле `event` принимает значение `pagination`
     * или `changeParams`.
     *
     * @param {app.Category} collection
     */
    eventCategory: function (collection) {
      if (!this.catalogParamsFlag && !this.catalogPaginationFlag) {
        return;
      }

      // т.к. при бесконечном скролле набор моделей суммируется то нужны только последние пришедшие модели
      if (this.catalogInfiniteScrollFlag) {
        collection = collection.slice(collection.state.itemsInResponse * (-1));
      }

      var that = this,
        pageH1 = document.getElementsByClassName('likeH1'),
        response = {
        event: 'pagination',
        ecommerce: {
          currencyCode: collection.currencyId,
          impressions: collection.map(function (item) {
            var itemData = that.getProductProperty(item, {category: collection.categoryId});
            if (pageH1.length && pageH1[0].textContent) {
              itemData.dimension1 = pageH1[0].textContent;
            }
            return itemData;
          })
        }
      };

      response.ecomm_pagetype = 'category';
      response.ecomm_prodid = this.getAdwordsProductData(response.ecommerce.impressions, 'id');
      response.ecomm_totalvalue = this.getAdwordsProductData(response.ecommerce.impressions, 'price');

      // @todo: спрятать по аналогии с поиском

      if (this.catalogParamsFlag) {
        response.event = 'changeParams';
      }
      this.catalogParamsFlag = false;
      this.catalogPaginationFlag = false;
      this.catalogInfiniteScrollFlag = false;

      this.pushData(response);
    },
    /**
     * Устанавливает флаг наличия параметров в каталоге
     */
    eventCategoryParams: function () {
      this.catalogParamsFlag = true;
    },
    /**
     * Устанавливает флаг наличия пагинации в каталоге
     */
    eventCategoryPagination: function () {
      this.catalogPaginationFlag = true;
    },
    /**
     * Устанавливает флаг наличия бесконечной прокрутки в каталоге
     */
    eventCategoryInfiniteScroll: function () {
      this.eventCategoryPagination();
      this.catalogInfiniteScrollFlag = true;
    },

    /**
     * Страница корзины, данные отправляются при загрузке, при смене товара на странице, если товар сменён без
     * перезагрузки страницы то дописывается поле `event` взависимости от причины смены товара имеет значение
     * `pagination` или `changeParams`.
     *
     * @param {app.Cart} collection
     */
    eventCart: function (collection) {
      // почему-то метод `sync` срабатывает при добавлении товара в корзину
      if (typeof collection.length === 'undefined') {
        return;
      }

      var that = this;

      var response = {
        event: 'checkout',
        ecommerce: {
          currencyCode: collection.currencyId,
          checkout: {
            actionField: {
              step: 1
            },
            products: collection.slice(collection.state.itemsInResponse * (-1)).map(function (item) {
              return that.getProductCartProperty(item);
            })
          }
        }
      };

      response.ecomm_pagetype = 'cart';
      response.ecomm_prodid = this.getAdwordsProductData(response.ecommerce.checkout.products, 'id');
      response.ecomm_totalvalue = this.getAdwordsProductData(response.ecommerce.checkout.products, 'price');

      // пагинация
      if (this.cartInfiniteScrollFlag) {
        response.event = 'pagination';
      }
      this.cartInfiniteScrollFlag = false;

      this.pushData(response);
    },
    /**
     * Устанавливает флаг наличия бесконечной прокрутки в корзине
     */
    eventCartInfiniteScroll: function () {
      this.cartInfiniteScrollFlag = true;
    },

    /**
     * Успешное оформление заказа, отправка данных о выбранных параметрах заказа.
     *
     * @param {app.Order} model
     * @todo не уверен что это будет всегда успевать отправляться в GTM
     */
    orderSuccess: function (model) {
      var orderOption = [];

      // способ доставки
      switch (parseInt(model.get('deliveryTypeId'))) {
        case 1:
          orderOption.push('Samovivoz');
          break;
        case 3:
          orderOption.push('Dostavka');
          break;
        case 5:
          orderOption.push('Call_me');
          break;
        default:
          orderOption.push('Undefined');
      }

      // способ оплаты
      switch (parseInt(model.get('paymentTypeId'))) {
        case 0:
          orderOption.push('Bank');
          break;
        case 1:
          orderOption.push('Visa');
          break;
        case 2:
          orderOption.push('Cash');
          break;
        default:
          orderOption.push('Undefined');
      }

      this.pushData({
        event: 'checkoutOption',
        ecommerce: {
          checkout_option: {
            actionField: {
              step: 2,
              option: orderOption.join('-')
            }
          }
        }
      });
    },

    /**
     * Страница избранного. Данные отправляются в `ecommerce` только если произошла смена товара
     * без перезагрузки страницы. Взависимости от причины смены товара поле `event` принимает значение `pagination`
     * или `changeParams`.
     *
     * @param {app.WishItems} collection
     */
    eventWish: function (collection) {
      if (!this.wishParamsFlag && !this.wishPaginationFlag) {
        return;
      }

      // т.к. при бесконечном скролле набор моделей суммируется то нужны только последние пришедшие модели
      if (this.wishInfiniteScrollFlag) {
        collection = collection.slice(collection.state.itemsInResponse * (-1));
      }

      var that = this,
        response = {
        event: 'pagination',
        ecommerce: {
          currencyCode: collection.currencyId,
          impressions: collection.map(function (item) {
            return that.getProductProperty(item);
          })
        }
      };

      response.ecomm_pagetype = 'wish';
      response.ecomm_prodid = this.getAdwordsProductData(response.ecommerce.impressions, 'id');
      response.ecomm_totalvalue = this.getAdwordsProductData(response.ecommerce.impressions, 'price');

      // @todo: спрятать по аналогии с поиском

      if (this.wishParamsFlag) {
        response.event = 'changeParams';
      }

      this.wishParamsFlag = false;
      this.wishPaginationFlag = false;
      this.wishInfiniteScrollFlag = false;

      this.pushData(response);
    },
    eventWishParams: function () {
      this.wishParamsFlag = true;
    },
    eventWishPagination: function () {
      this.wishPaginationFlag = true;
    },
    eventWishInfiniteScroll: function () {
      this.eventWishPagination();
      this.wishInfiniteScrollFlag = true;
    },

    // изменения отображения фильтра
    toggleFilterView: function (event) {
      var $target = $(event.currentTarget),
        $parent = $target.parents('section'),
        data = {
          event: 'Filter'
        };
      // свернуть/развернуть фильтр
      if ($target.hasClass('h3')) {
        data.Condition = $parent.find('.section-inside').css('display') === 'none' ? 'Свернуть' : 'Развернуть';
        // fix для мобильной версии: название фильтра содержит его выставленные параметры
        data.FilterName = $parent.find('section').hasClass('price') ? 'Цена' : $target.text();
      } else {
        // показать/скрыть параметры фильтра
        data.Condition = $target.text().indexOf('Скрыть') !== -1 ? 'Скрыть' : 'Показать ещё';
        data.FilterName = $parent.find('.h3').text();
      }
      this.pushData(data);
    },

    /**
     * Отправляет данные в dataLayer.
     *
     * @param data
     */
    pushData: function (data) {
      if (window.location.search.match('SIMA_NO_GTM') === null) {
        this.dataLayer.push(data);
      }
    },

    /**
     * Выбирает значимые для `ecommerce` свойства объекта.
     *
     * @param {app.CartItem} item
     * @returns {{id: integer, price: float, category: integer, variant: String, quantity: integer}}
     */
    getProductCartProperty: function (item) {
      return this.getProductProperty(
        item,
        {
          id: 'item_sid',
          quantity: 'qty',
          name: 'item.name'
        }
      );
    },

    /**
     * Формирует объект с данными товара
     *
     * @param {app.CartItem} productObj
     * @param productMap карта преобразования данных товара в выходные данные
     * @returns {{}}
     */
    getProductProperty: function (productObj, productMap) {
      var defaultProductMap = {
        id: 'sid',
        price: 'price',
        category: 'category_id',
        variant: 'ecommerce_variant',
        name: 'name'
      };

      productMap = _.extend(defaultProductMap, productMap) || defaultProductMap;

      var productProperty = {},
        map_i,
        value,
        map_v_split;

      for (map_i in productMap) {
        if (productMap.hasOwnProperty(map_i)) {
          if (_.isNumber(productMap[map_i])) {
            productProperty[map_i] = productMap[map_i];
          } else if (!_.isUndefined(productMap[map_i])) {
            map_v_split = productMap[map_i].split('.');
            value = productObj.get(map_v_split[0]);
            productProperty[map_i] = map_v_split.length > 1
              ? _.get(value, _.drop(map_v_split, 1).join('.'))
              : value;
          }

          // удаляем все пустые поля
          if (!productProperty[map_i] && productProperty[map_i] !== 0) {
            delete productProperty[map_i];
          }
        }
      }

      return productProperty;
    },

    getAdwordsProductData: function (productList, paramName) {
      if (productList === undefined) {
        return [];
      }

      return productList.slice(0, 10).map(function (item) {
        return item[paramName];
      });
    }

  });
})();

}.call(window));